var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"enroll-info"},_vm._l((_vm.list),function(i,idx){return _c('li',{key:idx,staticClass:"row"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(i.title))]),_c('span',{staticClass:"content"},[_vm._v(_vm._s(i.content))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }